import DOMPurify from 'dompurify';

export class PharmacyForm {
	constructor(el) {
		this.searchInputEle = document.getElementById("telemedicine_intakes_v2_pharmacy_form_intake_pharmacy")
		this.selectedInputEle = document.getElementById('telemedicine_intakes_v2_pharmacy_form_athena_clinical_provider_id')
		this.pharmacyList = document.getElementById("pharmacies-list")
		this.selectedPharmacy = document.getElementById("selected-pharmacy")
		this.selectedPharmacyData = document.getElementById("selected-pharmacy-data")

		const debounce = (func, delay) => {
			let debounceTimer
			return function () {
				if (this.searchInputEle.value.length < 3) {
					this.pharmacyList.style.display = "none"
				}
				const context = this
				const args = arguments
				clearTimeout(debounceTimer)
				debounceTimer = setTimeout(() => func.apply(context, args), delay)
			}.bind(this)
		}

		this.searchInputEle.addEventListener('keyup', debounce(function () {
			if (this.searchInputEle.value.length > 2) {
				var xhttp = new XMLHttpRequest()
				xhttp.onreadystatechange = function () {
					if (this.readyState == 4 && this.status == 200) {
						var pharmacyDetails = JSON.parse(this.responseText)
						var nodes = ''
						var nodeIds = []
						if (pharmacyDetails.length > 0) {
							for (var i = 0; i < pharmacyDetails.length; i++) {
								if (parseFloat(pharmacyDetails[i].distance) < 25) {
									nodes += '<div class="pharmacy-details" id="ph-' + pharmacyDetails[i].facilityid + '">' +
										pharmacyDetails[i].name + '</br>' + pharmacyDetails[i].address + ', ' + pharmacyDetails[i].city + ', ' +
										pharmacyDetails[i].state + ', ' + pharmacyDetails[i].zipcode + '</div>'
									nodeIds.push(pharmacyDetails[i].facilityid)
									if (nodeIds.length === 10) { break }
								}
							}
						}
						if (nodeIds.length === 0) {
							nodes = '<div class="pharmacy-row list-css"><p class="pharmacy-name" >No pharmacies found</p><p>Try entering a different pharmacy name or address</p></div>'
							document.getElementById("selected-pharmacy").style.display = "none"
							document.getElementById("selected-pharmacy").style.padding = "0px"
						}
						var pharmaciesList = document.getElementById('pharmacies-list')
						pharmaciesList.style.display = "block"
						pharmaciesList.innerHTML = nodes
						if (nodeIds.length > 0) {
							nodeIds.forEach(function (nodeId) {
								document.getElementById("ph-" + nodeId).addEventListener('click', (e) => {
									var selected_pharmacy_id = e.currentTarget.id
									document.getElementById('telemedicine_intakes_v2_pharmacy_form_athena_clinical_provider_id').value = selected_pharmacy_id.replace("ph-", "")
									var selected_pharmacy = document.getElementById(selected_pharmacy_id)
									document.getElementById("selected-pharmacy").style.display = "block"
									document.getElementById("selected-pharmacy").style.padding = "5px 0px"
									document.getElementById("pharmacies-list").style.display = "none"
									document.getElementById("selected-pharmacy-data").innerHTML = DOMPurify.sanitize(selected_pharmacy.innerHTML)
								})
							})
						}
					}
				}

				xhttp.onloadstart = () => {
					document.getElementById("search-info").innerHTML = "Searching..."
				}

				xhttp.onloadend = () => {
					document.getElementById("search-info").innerHTML = "Click on your preferred Pharmacy"
				}
				xhttp.open("GET", "search?search_string=" + this.searchInputEle.value, true)
				xhttp.send()
			}
		}.bind(this), 2000))
	}
}